import axios from '@/views/external_segmented_survey/axios';
import { handleAxiosError } from '@/helpers';
import { useToast } from 'vue-toastification';

export default {
    namespaced: true,

    state: () => ({
        company: null,
        terms: null,
        show_modal_terms: false,
        show_modal_update: false,
        load: false,
        errors: null,
    }),

    mutations: {
        setCompany(state, company) {
            state.company = company;
            if (company === null) {
                localStorage.removeItem('_user');
                localStorage.removeItem('_company');
                localStorage.removeItem('_token');
            } else {
                localStorage.setItem('_user', JSON.stringify(company));
                localStorage.removeItem('_company');
                localStorage.removeItem('_token');
            }
        },
        setTerms(state, terms) {
            state.terms = terms;
        },
        openModalTerms(state) {
            state.show_modal_terms = true;
        },
        closeModalTerms(state) {
            state.show_modal_terms = false;
        },
        openModalUpdate(state) {
            state.show_modal_update = true;
        },
        closeModalUpdate(state) {
            state.show_modal_update = false;
        }
    },

    getters: {
        isAuth(state) {
            return !!(state.company?.token);
        },
        permissions(state) {
            return state.company?.permissions;
        },
        initialLetters(state) {
            if (state.company) {
                const dataName = state.company.name.split(' ');
                return `${dataName[0].charAt(0)}${dataName[dataName.length - 1].charAt(0)}`.toUpperCase();
            }
            return '';
        },
        uuid(state) {
            return state.company?.uuid;
        },
        terms(state) {
            return state.terms;
        }
    },

    actions: {
        async logout({ state, commit }, data = {}) {
            const uuid = data?.uuid 
                ? data?.uuid 
                : state?.company?.segmented_survey?.uuid;
            
            try {
                await axios.post('segmented-survey/logout');
                commit('setCompany', null);
            } catch (e) {
                commit('setCompany', null);
            }finally {
                window.location.href = `/pesquisa-segmentada/${uuid}/login`;
            }
        },

        async update({ state, commit }, formData) {
            try {
                state.load = true;
                const { data } = await axios.put(`segmented-survey/me`, formData);
                
                state.company = { ...state.company, ...data.data };
                commit('setCompany', state.company);
                useToast().success('Dados atualizados com sucesso!');
            } catch (e) {
                handleAxiosError(e);
            }finally {
                state.load = false;
            }
        },
        
        async updateStage({ state, commit }, stage) {
            try {
                const company = state.company;
                const segmentedSurvey = state.company.segmented_survey;
                await axios.put(`segmented-survey/${segmentedSurvey.uuid}/companies/${company.cnpj}/stages`, {
                    'stage': stage,
                });
                company.forms_info.current_stage = stage;
                commit('setCompany', company);
            } catch (e) {
                handleAxiosError(e);
            }
        },
        
        async refresh({ state, commit }) {
            try {
                const segmentedSurvey = state.company.segmented_survey;
                const { data } = await axios.get(`segmented-survey/${segmentedSurvey.uuid}/me`);
                commit('setCompany', data);
            } catch (e) {
                handleAxiosError(e);
            }
        },
        
        loadCompanyData({ state, commit }) {
            if (!state.company) {
                try {
                    const storageCompany = JSON.parse(localStorage.getItem('_user'));
                    commit('setCompany', storageCompany);
                }catch (e) {
                    commit('setCompany', null);
                }
            }
        },
        
        async getTerms({ state, commit }) {
            try {
                const { data } = await axios.get('/segmented-survey/terms');
                commit('setTerms', data);
            }catch (error) {
                handleAxiosError(error);
            }
        },
        
        async acceptTerm({ state, commit }) {
            try {
                const cnpj = state?.company?.cnpj;
                const uuid = state?.company?.segmented_survey?.uuid;
                const { data } = await axios.post(`/segmented-survey/${uuid}/companies/${cnpj}/accept-terms`, {
                    term_id: state.terms?.id, 
                });
                
                commit('setCompany', {
                    ...state.company,
                    'terms': [state.terms],
                    'accepted_terms': true
                });
                (useToast()).success(data?.message);
            }catch (error) {
                handleAxiosError(error);
            }
        },
        
        async checkToken({}, uuid) {
            try {
                await axios.get(`/segmented-survey/${uuid}/login/check-token`);
            }catch(e) {
                if (e.response.status === 400 || e.response.status === 401 || e.response.status === 403) {
                    if (e.response.status === 400) {
                        await Swal.fire('Ação Negada', e.response.data.message, 'warning');
                    }
                    window.location.href = '/login';
                }else {
                    handleAxiosError(e);
                }
            }
        }
    }
};
